import { P as PolicyCard, L as LineOfCoverageCard$1, a as useEnrichedLocByUuid, b as LineOfCoverageDisplayInner, I as InsurableItemCoverageDisplay } from '../../dist/use-policy-1760ed5d.esm.js';
export { L as LineOfCoverageCard, d as LineOfCoverageDataDisplay, e as LineOfCoverageDataInput, c as LineOfCoverageExpandableDisplay, P as PolicyCard, u as usePolicy } from '../../dist/use-policy-1760ed5d.esm.js';
import { useFuzzy, SingleObjectSelector, DetailCard, SelectInput, Stack, Field, CalendarDatePickerInput, MultiObjectSelector, IconButton, colors, SegmentedControl, Flexbox, CircleSpinnerInline, Text, DefinitionList, FeaturedCard, Badge, Modal, ModalBody, ModalHeader, ObjectSelector, ModalFooter, Button, Padding, MessageBox, ObjectSelectionInput, Spacing, Columns, DatePickerInput2, Input, TextareaAutosize, ActionModal, Alert, usePopover, Portal, Tether, PopoverAnimation, Box, Menu, Sheet, SheetHeader, SheetBody, SmallCaps, ExpandableModule, Popper, LineClamp, AdvancedSelectInput, MultiObjectSelect, ModalPortalProvider, EmployeeProfile, IconPlus } from '@newfront-insurance/core-ui';
import React, { useEffect, useState, Suspense, useMemo, useCallback, useRef } from 'react';
import { u as useAdminTRPC } from '../../dist/trpc-2b4d7b2f.esm.js';
import { CalendarDate, DateFormatStyle } from '@newfront-insurance/string-formatters';
import { P as POLICY_TERMS } from '../../dist/terms-1d940b59.esm.js';
import _extends from '@babel/runtime/helpers/esm/extends';
import { PolicyStatus, InsurableItemStatus, PolicyAssignmentRole } from '@newfront-insurance/coverage-api';
import { L as LineOfCoverageStatus } from '../../dist/line-of-coverage-851873c4.esm.js';
import { DSLSpreadsheet } from '@newfront-insurance/spreadsheet';
import { CellPopover, CellPopoverFooter } from '@newfront-insurance/spreadsheet/dist/src/components/table/popover';
import { Formik, useFormikContext, useFormik, FormikProvider, Form } from 'formik';
import { useToggle } from 'react-use';
import { SchemaDisplay, FormikSchemaInput, getFieldLabel, getStringifiedFieldValueFromSchema, getSingleLineSchemaIdentifier } from '@newfront-insurance/dsl-schema-ui';
import { useNotifications } from '@newfront-insurance/next-notifications';
import find from 'lodash/find';
import get from 'lodash/get';
import { isNotUndefined, toRecord } from '@newfront-insurance/core';
import { useHoverIntent } from 'react-use-hoverintent';
import { AM_ROLES, PRODUCER_ROLES } from '@newfront-insurance/auth-api';
import uniqBy from 'lodash/uniqBy';
import { u as useAccountByUuid, b as useProducers, a as useAccountManagers } from '../../dist/use-producers-e83851ce.esm.js';
import '../../dist/schemas-21e94256.esm.js';
import '@newfront-insurance/users-api';
import 'tiny-invariant';
import 'yup';
import '@newfront-insurance/account-api';
import 'fuse.js';
import 'lodash.noop';
import 'smartystreets-javascript-sdk';
import '../../dist/smarty-street-public-key-85081a7e.esm.js';
import '@newfront-insurance/account-common';
import '@newfront-insurance/core-money';
import 'styled-components';
import 'pluralize';
import '@newfront-insurance/react-provision';
import '@newfront-insurance/data-layer-client';
import 'lodash/debounce';
import 'postal-codes-js';
import 'react-highlight-words';

function usePolicyDefinitions(options) {
  const {
    useQuery
  } = useAdminTRPC();
  return useQuery(['policies.getDefinitions'], options);
}

const QUERY_DEBOUNCE_MS = 500;
const FUZZY_OPTIONS$1 = {
  keys: ['readableName'],
  debounce: QUERY_DEBOUNCE_MS
};
function PolicyTypeSelector(_ref) {
  let {
    value,
    onChange
  } = _ref;
  const {
    isLoading,
    data
  } = usePolicyDefinitions();
  const {
    results: filteredPolicyTypeDefinitions,
    search
  } = useFuzzy((data === null || data === void 0 ? void 0 : data.policyTypeDefinitions) ?? [], FUZZY_OPTIONS$1);
  return /*#__PURE__*/React.createElement(SingleObjectSelector, {
    isLoading: isLoading,
    getItemKey: policy => policy.id,
    itemToString: policy => (policy === null || policy === void 0 ? void 0 : policy.readableName) ?? `No readable name`,
    items: filteredPolicyTypeDefinitions ?? [],
    onSelect: policyTypeDefinition => {
      onChange(policyTypeDefinition ?? undefined);
    },
    renderItem: (item, _ref2) => {
      let {
        isHovering,
        isSelected
      } = _ref2;
      return /*#__PURE__*/React.createElement(DetailCard, {
        title: item.readableName,
        isHighlighted: isSelected,
        isHovering: isHovering,
        cardProps: {
          hideBorder: true,
          hasRadius: false
        }
      });
    },
    selectedItem: value ?? null,
    onSearch: search
  });
}

function PolicyTermSelect(props) {
  const {
    onChange,
    value,
    disabled
  } = props;
  return /*#__PURE__*/React.createElement(SelectInput // since SelectInput only works with strings, we need to map month values to use them as strings
  , {
    options: POLICY_TERMS.map(policyTerm => ({ ...policyTerm,
      value: policyTerm.value.toString()
    })).concat({
      label: 'Other',
      value: 'other'
    }),
    testId: "policy-term-select",
    onChange: nextValue => {
      if (nextValue === 'other') {
        return onChange(null);
      } // convert it back to number


      onChange(parseInt(nextValue, 10));
    } // null means "Other", undefined means that the select wasn't set yet
    ,
    value: value === null ? 'other' : value === null || value === void 0 ? void 0 : value.toString(),
    disabled: disabled,
    showSelectAnOption: true,
    placeholder: "Select policy term"
  });
}

function PolicyTermFields(_ref) {
  let {
    values,
    errors,
    onChange,
    labels = {
      policyTerm: 'Policy term',
      effectiveDate: 'Effective date',
      expirationDate: 'Expiration date'
    },
    disabled = false
  } = _ref;
  const isDisabled = disabled;
  const policyTermDisabled = !!values.policyTerm;
  useEffect(() => {
    if (values.policyTerm) {
      onChange({ ...values,
        policyTerm: values.policyTerm,
        expirationDate: getExpirationDateByEffectiveDate(values.effectiveDate ? CalendarDate.fromDate(values.effectiveDate) : null, values.policyTerm)
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [values.policyTerm, values.effectiveDate]);
  return /*#__PURE__*/React.createElement(Stack, {
    gap: 16,
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Field, {
    fieldId: "coverage-policy-term",
    label: labels.policyTerm ?? 'Policy term',
    error: errors === null || errors === void 0 ? void 0 : errors.policyTerm
  }, /*#__PURE__*/React.createElement(PolicyTermSelect, {
    onChange: policyTerm => {
      onChange({ ...values,
        policyTerm,
        expirationDate: getExpirationDateByEffectiveDate(values.effectiveDate ? CalendarDate.fromDate(values.effectiveDate) : null, policyTerm)
      });
    },
    value: values.policyTerm,
    disabled: isDisabled
  })), /*#__PURE__*/React.createElement(Stack, {
    gap: 16,
    isFluid: true
  }, /*#__PURE__*/React.createElement(Field, {
    fieldId: "coverage-effective-date",
    label: labels.effectiveDate ?? 'Effective date',
    error: errors === null || errors === void 0 ? void 0 : errors.effectiveDate
  }, /*#__PURE__*/React.createElement(CalendarDatePickerInput, {
    fieldId: "coverage-effective-date",
    name: "effective-date",
    value: values.effectiveDate ? CalendarDate.fromDate(values.effectiveDate, 'UTC') : undefined,
    testId: "effective-date",
    onChange: date => {
      onChange({ ...values,
        effectiveDate: date === null || date === void 0 ? void 0 : date.toDate('UTC').toISOString(),
        expirationDate: getExpirationDateByEffectiveDate(date, values.policyTerm)
      });
    },
    disabled: isDisabled
  })), /*#__PURE__*/React.createElement(Field, {
    fieldId: "coverage-expiration-date",
    label: labels.expirationDate ?? 'Expiration date',
    error: errors === null || errors === void 0 ? void 0 : errors.expirationDate
  }, /*#__PURE__*/React.createElement(CalendarDatePickerInput, {
    fieldId: "coverage-expiration-date",
    name: "expiration-date",
    value: values.expirationDate ? CalendarDate.fromDate(values.expirationDate, 'UTC') : undefined,
    minDate: values.expirationDate ? CalendarDate.fromDate(values.expirationDate, 'UTC') : undefined,
    testId: "expiration-date",
    onChange: date => {
      onChange({ ...values,
        expirationDate: date === null || date === void 0 ? void 0 : date.toDate('UTC').toISOString()
      });
    },
    disabled: policyTermDisabled || isDisabled
  }))));
}

function getExpirationDateByEffectiveDate(effectiveDate, policyTerm) {
  if (!policyTerm || !effectiveDate) {
    return '';
  }

  const expirationDate = effectiveDate.addMonths(policyTerm);
  return expirationDate.toDate('UTC').toISOString();
}

function useLineOfCoverageDefinitions(options) {
  const {
    useQuery
  } = useAdminTRPC();
  return useQuery(['loc.getAllLocDefinitions'], options);
}

function LineOfCoverageTypeSelector(_ref) {
  let {
    selectedType,
    setSelectedType
  } = _ref;
  const {
    data: lineOfCoverageDefinitions
  } = useLineOfCoverageDefinitions({
    suspense: true,
    refetchOnMount: false,
    keepPreviousData: true
  });
  const {
    results,
    search
  } = useFuzzy(lineOfCoverageDefinitions ?? [], {
    keys: ['readableName']
  });

  if (!lineOfCoverageDefinitions) {
    return null;
  }

  return /*#__PURE__*/React.createElement(SingleObjectSelector, {
    items: results,
    itemToString: def => (def === null || def === void 0 ? void 0 : def.readableName) ?? '',
    getItemKey: def => def === null || def === void 0 ? void 0 : def.id,
    onSelect: def => setSelectedType(def),
    renderItem: (def, _ref2) => {
      let {
        isHovering,
        isSelected
      } = _ref2;
      return /*#__PURE__*/React.createElement(DetailCard, {
        title: def === null || def === void 0 ? void 0 : def.readableName,
        isHighlighted: isSelected,
        isHovering: isHovering,
        cardProps: {
          hideBorder: true,
          hasRadius: false
        }
      });
    },
    selectedItem: selectedType,
    onSearch: search
  });
}

function MultiPolicySelector(_ref) {
  let {
    policies,
    selectedPolicies,
    onSelectedPolicies: setSelectedPolicies,
    ...props
  } = _ref;
  const [filter, setFilter] = useState(PolicyStatus.ACTIVE);
  const filteredPolicies = policies.filter(policy => policy.status === filter);
  const {
    results,
    search
  } = useFuzzy(filteredPolicies, {
    keys: ['definition.readableName', 'policyNumber', 'details.displayName'],
    debounce: 300
  });
  return /*#__PURE__*/React.createElement(MultiObjectSelector, _extends({
    items: results,
    itemToString: policy => (policy === null || policy === void 0 ? void 0 : policy.displayName) ?? '',
    getItemKey: policy => policy.uuid,
    renderItem: (policy, _ref2) => {
      let {
        isHovering,
        isSelected
      } = _ref2;
      return /*#__PURE__*/React.createElement(PolicyCard, {
        policy: policy,
        isExpandable: false,
        defaultExpanded: false,
        isHighlighted: isSelected,
        isHovering: isHovering,
        cardProps: {
          hideBorder: true,
          hasRadius: false
        },
        selectableOptions: {
          type: 'multiple',
          isSelected
        }
      });
    },
    renderSelectedItems: (policy, _ref3) => {
      let {
        remove
      } = _ref3;
      return /*#__PURE__*/React.createElement(PolicyCard, {
        policy: policy,
        actions: [/*#__PURE__*/React.createElement(IconButton, {
          type: "close",
          onClick: remove
        })],
        isExpandable: true,
        defaultExpanded: true,
        cardProps: {
          backgroundColor: colors.steel[50],
          hideBorder: true
        }
      });
    },
    renderItemHover: policy => /*#__PURE__*/React.createElement("div", {
      style: {
        width: 460
      }
    }, /*#__PURE__*/React.createElement(PolicyCard, {
      isExpandable: true,
      defaultExpanded: true,
      policy: policy
    })),
    renderInputToolbar: _ref4 => {
      let {
        focusInput
      } = _ref4;
      return /*#__PURE__*/React.createElement(SegmentedControl, {
        onChange: value => {
          setFilter(value);
          focusInput();
        },
        variant: "thin",
        value: filter,
        options: [{
          value: PolicyStatus.ACTIVE,
          label: 'Active'
        }, {
          value: PolicyStatus.UPCOMING,
          label: 'Upcoming'
        }, {
          value: PolicyStatus.EXPIRED,
          label: 'Expired'
        }]
      });
    },
    onSelect: policies => {
      setSelectedPolicies(policies);
    },
    selectedItems: selectedPolicies,
    onSearch: search // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
}

function SinglePolicySelector(_ref) {
  let {
    policies,
    selectedPolicy,
    onSelectedPolicy: setSelectedPolicy,
    ...props
  } = _ref;
  const [filter, setFilter] = useState(PolicyStatus.ACTIVE);
  const filteredPolicies = policies.filter(policy => policy.status === filter);
  const {
    results,
    search
  } = useFuzzy(filteredPolicies, {
    keys: ['definition.readableName', 'policyNumber', 'details.displayName'],
    debounce: 300
  });
  return /*#__PURE__*/React.createElement(SingleObjectSelector, _extends({
    items: results,
    itemToString: policy => (policy === null || policy === void 0 ? void 0 : policy.displayName) ?? '',
    getItemKey: policy => policy.uuid,
    onSelect: policy => setSelectedPolicy(policy ?? undefined),
    renderItem: (policy, _ref2) => {
      let {
        isHovering,
        isSelected
      } = _ref2;
      return /*#__PURE__*/React.createElement(PolicyCard, {
        policy: policy,
        isExpandable: false,
        defaultExpanded: false,
        isHighlighted: isSelected,
        isHovering: isHovering,
        cardProps: {
          hideBorder: true,
          hasRadius: false
        }
      });
    },
    renderItemHover: policy => /*#__PURE__*/React.createElement("div", {
      style: {
        width: 460
      }
    }, /*#__PURE__*/React.createElement(PolicyCard, {
      isExpandable: true,
      defaultExpanded: true,
      policy: policy
    })),
    renderInputToolbar: _ref3 => {
      let {
        focusInput
      } = _ref3;
      return /*#__PURE__*/React.createElement(SegmentedControl, {
        onChange: value => {
          setFilter(value);
          focusInput();
        },
        value: filter,
        options: [{
          value: PolicyStatus.ACTIVE,
          label: 'Active'
        }, {
          value: PolicyStatus.UPCOMING,
          label: 'Upcoming'
        }, {
          value: PolicyStatus.EXPIRED,
          label: 'Expired'
        }]
      });
    },
    selectedItem: selectedPolicy,
    onSearch: search // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
}

function MultiLineOfCoverageSelector(_ref) {
  let {
    linesOfCoverage,
    selectedLinesOfCoverage,
    onSelect,
    ...props
  } = _ref;
  const [filter, setFilter] = useState(LineOfCoverageStatus.ACTIVE);
  const filteredLinesofCoverage = linesOfCoverage.filter(lineOfCoverage => lineOfCoverage.statusLabel === filter);
  const {
    results,
    search
  } = useFuzzy(filteredLinesofCoverage ?? [], {
    keys: ['lineOfCoverage.title', 'lineOfCoverage.policy.policyNumber', 'lineOfCoverage.policy.carrier.name', 'lineOfCoverage.policy.definition.readableName']
  });
  return /*#__PURE__*/React.createElement(MultiObjectSelector, _extends({
    items: results,
    itemToString: lineOfCoverage => (lineOfCoverage === null || lineOfCoverage === void 0 ? void 0 : lineOfCoverage.title) ?? '',
    getItemKey: lineOfCoverage => lineOfCoverage.uuid,
    renderItem: (lineOfCoverage, _ref2) => {
      let {
        isHovering,
        isSelected
      } = _ref2;
      return /*#__PURE__*/React.createElement(LineOfCoverageCard$1, {
        lineOfCoverage: lineOfCoverage,
        isHighlighted: isSelected,
        isHovering: isHovering,
        cardProps: {
          hideBorder: true
        },
        defaultExpanded: false
      });
    },
    renderItemHover: lineOfCoverage => /*#__PURE__*/React.createElement("div", {
      style: {
        width: 460
      }
    }, /*#__PURE__*/React.createElement(LineOfCoverageCard$1, {
      defaultExpanded: true,
      lineOfCoverage: lineOfCoverage
    })),
    onSelect: linesOfCoverage => {
      onSelect(linesOfCoverage);
    },
    renderSelectedItems: (lineOfCoverage, _ref3) => {
      let {
        remove
      } = _ref3;
      return /*#__PURE__*/React.createElement(LineOfCoverageCard$1, {
        lineOfCoverage: lineOfCoverage,
        actions: [/*#__PURE__*/React.createElement(IconButton, {
          type: "close",
          onClick: remove
        })],
        isExpandable: true,
        defaultExpanded: true,
        cardProps: {
          backgroundColor: colors.steel[50],
          hideBorder: true
        }
      });
    },
    renderInputToolbar: _ref4 => {
      let {
        focusInput
      } = _ref4;
      return /*#__PURE__*/React.createElement(SegmentedControl, {
        onChange: value => {
          setFilter(value);
          focusInput();
        },
        variant: "thin",
        value: filter,
        options: [{
          value: LineOfCoverageStatus.ACTIVE,
          label: 'Active'
        }, {
          value: LineOfCoverageStatus.UPCOMING,
          label: 'Upcoming'
        }, {
          value: LineOfCoverageStatus.EXPIRED,
          label: 'Expired'
        }]
      });
    },
    selectedItems: selectedLinesOfCoverage,
    onSearch: search // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
}

function SingleLineOfCoverageSelector(_ref) {
  let {
    linesOfCoverage,
    selectedLineOfCoverage,
    onSelect,
    ...props
  } = _ref;
  const [filter, setFilter] = useState(LineOfCoverageStatus.ACTIVE);
  const filteredLinesofCoverage = linesOfCoverage.filter(lineOfCoverage => lineOfCoverage.statusLabel === filter);
  const {
    results,
    search
  } = useFuzzy(filteredLinesofCoverage ?? [], {
    keys: ['lineOfCoverage.title', 'lineOfCoverage.policy.policyNumber', 'lineOfCoverage.policy.carrier.name', 'lineOfCoverage.policy.definition.readableName']
  });
  return /*#__PURE__*/React.createElement(SingleObjectSelector, _extends({
    items: results,
    itemToString: lineOfCoverage => (lineOfCoverage === null || lineOfCoverage === void 0 ? void 0 : lineOfCoverage.title) ?? '',
    getItemKey: lineOfCoverage => lineOfCoverage.uuid,
    renderItem: (lineOfCoverage, _ref2) => {
      let {
        isHovering,
        isSelected
      } = _ref2;
      return /*#__PURE__*/React.createElement(LineOfCoverageCard$1, {
        lineOfCoverage: lineOfCoverage,
        isHighlighted: isSelected,
        isHovering: isHovering,
        cardProps: {
          hideBorder: true
        },
        defaultExpanded: false
      });
    },
    renderItemHover: lineOfCoverage => /*#__PURE__*/React.createElement("div", {
      style: {
        width: 460
      }
    }, /*#__PURE__*/React.createElement(LineOfCoverageCard$1, {
      defaultExpanded: true,
      lineOfCoverage: lineOfCoverage
    })),
    onSelect: linesOfCoverage => {
      onSelect(linesOfCoverage);
    },
    renderInputToolbar: _ref3 => {
      let {
        focusInput
      } = _ref3;
      return /*#__PURE__*/React.createElement(SegmentedControl, {
        onChange: value => {
          setFilter(value);
          focusInput();
        },
        value: filter,
        options: [{
          value: LineOfCoverageStatus.ACTIVE,
          label: 'Active'
        }, {
          value: LineOfCoverageStatus.UPCOMING,
          label: 'Upcoming'
        }, {
          value: LineOfCoverageStatus.EXPIRED,
          label: 'Expired'
        }]
      });
    },
    selectedItem: selectedLineOfCoverage ?? null,
    onSearch: search // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
}

function LineOfCoverageDisplay(_ref) {
  let {
    lineOfCoverageUuid,
    canManage = false,
    isLineageFeatureFlagOn,
    getLineOfCoverageDetailsLink,
    getPolicyDetailsLink
  } = _ref;
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Flexbox, {
      justifyContent: "center",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(CircleSpinnerInline, null))
  }, /*#__PURE__*/React.createElement(LineOfCoverageDisplaySuccess, {
    lineOfCoverageUuid: lineOfCoverageUuid,
    canManage: canManage,
    getLineOfCoverageDetailsLink: getLineOfCoverageDetailsLink,
    getPolicyDetailsLink: getPolicyDetailsLink,
    isLineageFeatureFlagOn: isLineageFeatureFlagOn
  }));
}

function LineOfCoverageDisplaySuccess(_ref2) {
  let {
    lineOfCoverageUuid,
    canManage = false,
    isLineageFeatureFlagOn,
    getLineOfCoverageDetailsLink,
    getPolicyDetailsLink
  } = _ref2;
  const {
    data: lineOfCoverage
  } = useEnrichedLocByUuid({
    lineOfCoverageUuid
  }, {
    suspense: true
  });

  if (!lineOfCoverage) {
    return null;
  }

  return /*#__PURE__*/React.createElement(LineOfCoverageDisplayInner, {
    lineOfCoverage: lineOfCoverage,
    isLineageFeatureFlagOn: isLineageFeatureFlagOn,
    canManage: canManage,
    getLineOfCoverageDetailsLink: getLineOfCoverageDetailsLink,
    getPolicyDetailsLink: getPolicyDetailsLink
  });
}

/**
 * Display that given a insurable item fetches the corresponding schema and renders the display with values.
 */
function InsurableItemDisplay(_ref) {
  let {
    insurableItemDetails,
    onlyDslData
  } = _ref;
  const {
    displayName,
    notes,
    type: insurableItemType,
    data: insurableItemData,
    schema
  } = insurableItemDetails;
  return /*#__PURE__*/React.createElement(Flexbox, {
    gap: 32,
    flexDirection: "column"
  }, !onlyDslData && /*#__PURE__*/React.createElement(Flexbox, {
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    color: "light"
  }, "Display name"), /*#__PURE__*/React.createElement(Text, {
    size: "regular",
    color: "dark",
    weight: 300
  }, displayName ?? '')), /*#__PURE__*/React.createElement(SchemaDisplay, {
    name: insurableItemType,
    schema: schema,
    values: insurableItemData // TODO: improve the types in dsl-schema-ui

  }), !onlyDslData && /*#__PURE__*/React.createElement(Flexbox, {
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    color: "light"
  }, "Notes"), /*#__PURE__*/React.createElement(Text, {
    prewrap: true,
    size: "regular",
    color: "dark",
    weight: 300
  }, notes ?? '')));
}

function useEnrichedLocs(params, options) {
  const {
    useQuery
  } = useAdminTRPC();
  return useQuery(['loc.getLocs', params], options);
}

function useInsurableItemIdentifier(params, options) {
  const {
    useQuery
  } = useAdminTRPC();
  return useQuery(['insurableItems.getReadableValues', params], options);
}

function renderPolicyName(policyType, displayName) {
  if (displayName) {
    return `${displayName} - ${policyType}`;
  }

  return policyType;
}

function LineOfCoverageDefinitionList(props) {
  const {
    lineOfCoverage
  } = props;
  return /*#__PURE__*/React.createElement(DefinitionList, {
    items: createCoverageDefinitionList(lineOfCoverage),
    labelWidth: "150px"
  });
}
function createCoverageDefinitionList(lineOfCoverage) {
  const {
    startDate,
    endDate
  } = lineOfCoverage;
  const {
    policyNumber,
    details: {
      displayName
    },
    definition,
    type
  } = lineOfCoverage.policy;
  const items = [{
    type: 'document',
    title: 'Policy',
    value: renderPolicyName((definition === null || definition === void 0 ? void 0 : definition.readableName) ?? type, displayName)
  }, {
    type: 'number',
    title: 'Policy number',
    value: policyNumber,
    href: '#'
  }];

  if (startDate && !endDate) {
    items.push({
      type: 'dateRange',
      title: 'Effective date',
      value: `${startDate.format({
        style: DateFormatStyle.STANDARD
      })}`
    });
  }

  if (!startDate && endDate) {
    items.push({
      type: 'dateRange',
      title: 'Expiration date',
      value: `${endDate.format({
        style: DateFormatStyle.STANDARD
      })}`
    });
  }

  if (startDate && endDate) {
    items.push({
      type: 'dateRange',
      title: 'Effective dates',
      value: `${startDate.format({
        style: DateFormatStyle.STANDARD
      })} - ${endDate.format({
        style: DateFormatStyle.STANDARD
      })}`
    });
  }

  return items;
}

function LineOfCoverageCard(_ref) {
  var _lineOfCoverage$defin, _lineOfCoverage$defin2;

  let {
    lineOfCoverage,
    href,
    onClick,
    selectType = 'checkbox',
    target,
    isExpandable = false,
    defaultExpanded = false,
    isSelected,
    onSelect,
    onRemove,
    menuItems
  } = _ref;
  const {
    startDate,
    endDate
  } = lineOfCoverage;
  const today = new Date();
  const startDateObj = startDate === null || startDate === void 0 ? void 0 : startDate.toDate('UTC');
  const endDateObj = endDate === null || endDate === void 0 ? void 0 : endDate.toDate('UTC');
  let statusBadge = /*#__PURE__*/React.createElement(React.Fragment, null);

  if (endDateObj && today > endDateObj) {
    statusBadge = /*#__PURE__*/React.createElement(Badge, {
      type: "secondary"
    }, "Expired");
  } else if (startDateObj && today < startDateObj) {
    statusBadge = /*#__PURE__*/React.createElement(Badge, {
      type: "info-outline"
    }, "Upcoming");
  } else if (startDateObj && today >= startDateObj) {
    statusBadge = /*#__PURE__*/React.createElement(Badge, {
      type: "success"
    }, "Active");
  }

  return /*#__PURE__*/React.createElement(FeaturedCard, {
    eyebrow: "Line of Coverage",
    title: lineOfCoverage.displayName ?? ((_lineOfCoverage$defin = lineOfCoverage.definition) === null || _lineOfCoverage$defin === void 0 ? void 0 : _lineOfCoverage$defin.readableName) ?? lineOfCoverage.type,
    subtitle: lineOfCoverage.displayName ? ((_lineOfCoverage$defin2 = lineOfCoverage.definition) === null || _lineOfCoverage$defin2 === void 0 ? void 0 : _lineOfCoverage$defin2.readableName) ?? lineOfCoverage.type : undefined,
    href: href,
    target: target,
    content: /*#__PURE__*/React.createElement(LineOfCoverageDefinitionList, {
      lineOfCoverage: lineOfCoverage
    }),
    isExpandable: isExpandable,
    defaultExpanded: defaultExpanded,
    onClick: onClick,
    onSelect: onSelect ? () => onSelect(lineOfCoverage) : undefined,
    onRemove: onRemove ? () => onRemove(lineOfCoverage) : undefined,
    isSelected: isSelected,
    selectType: selectType,
    badge: statusBadge,
    menuItems: menuItems
  });
}

function LegacyLineOfCoverageSelectorModal(_ref) {
  let {
    error,
    header,
    initialSelectedLineOfCoverageUuids,
    isOpen,
    linesOfCoverage,
    loading = false,
    onSubmit,
    onToggle,
    required = false,
    submitText,
    submitting = false,
    type
  } = _ref;
  const {
    query,
    results,
    search
  } = useFuzzy(linesOfCoverage, {
    keys: ['type', 'displayName', 'policy.type', 'policy.details.displayName', 'policy.name', 'policy.policyNumber', 'policy.carrier.name', 'policy.details.thirdParty']
  });
  const [selectedLineOfCoverageUuids, setSelectedLineOfCoverageUuids] = useState(initialSelectedLineOfCoverageUuids);
  useEffect(() => {
    setSelectedLineOfCoverageUuids(initialSelectedLineOfCoverageUuids);
  }, [initialSelectedLineOfCoverageUuids]);

  function handleSelection(lineOfCoverage) {
    if (type === 'multi') {
      setSelectedLineOfCoverageUuids(currentSelectedLineOfCoverageUuids => currentSelectedLineOfCoverageUuids.includes(lineOfCoverage.uuid || '') ? currentSelectedLineOfCoverageUuids.filter(lineOfCoverageUuid => lineOfCoverageUuid !== lineOfCoverage.uuid) : currentSelectedLineOfCoverageUuids.concat([lineOfCoverage.uuid ?? '']));
      return;
    }

    setSelectedLineOfCoverageUuids([lineOfCoverage.uuid ?? '']);
  }

  function isSelected(lineOfCoverage) {
    return selectedLineOfCoverageUuids.includes(lineOfCoverage.uuid ?? '');
  }

  function handleSubmit() {
    onSubmit(selectedLineOfCoverageUuids);
  }

  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onToggle: onToggle,
    width: "600px"
  }, /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(ModalHeader, {
    titleText: header,
    onClose: onToggle
  }), /*#__PURE__*/React.createElement(ObjectSelector, {
    loading: loading,
    error: error,
    placeholder: "No lines of coverage available",
    onSearchInputChange: search,
    searchInput: query
  }, (results === null || results === void 0 ? void 0 : results.length) > 0 && results.map(lineOfCoverage => /*#__PURE__*/React.createElement(LineOfCoverageCard, {
    key: lineOfCoverage.uuid,
    lineOfCoverage: lineOfCoverage,
    onSelect: () => handleSelection(lineOfCoverage),
    isSelected: isSelected(lineOfCoverage),
    selectType: type === 'multi' ? 'checkbox' : 'radio'
  }))), /*#__PURE__*/React.createElement(ModalFooter, {
    showBorder: true
  }, /*#__PURE__*/React.createElement(Stack, {
    gap: 8,
    direction: "horizontal",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onToggle,
    loading: submitting,
    size: "secondary"
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    onClick: handleSubmit,
    loading: submitting,
    disabled: required ? selectedLineOfCoverageUuids.length === 0 : false
  }, typeof submitText === 'function' ? submitText(selectedLineOfCoverageUuids) : submitText)))));
}

function LinkInsurableItem(_ref) {
  let {
    insurableItemUuid,
    onToggle,
    accountUuid,
    onSuccess
  } = _ref;
  const {
    data: linesOfCoverage,
    isLoading
  } = useEnrichedLocs({
    accountUuid,
    onlyAvailable: true
  });
  const {
    data: insurableItemIdentifier,
    isLoading: isLoadingInsurableItem
  } = useInsurableItemIdentifier({
    insurableItemUuid
  });
  const notifications = useNotifications();
  const {
    useMutation
  } = useAdminTRPC();
  const {
    mutateAsync: createScheduledItem
  } = useMutation('scheduledItems.create', {
    onSuccess: async () => {
      await (onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess());
      onToggle();
      notifications.add({
        type: 'success',
        title: 'Scheduled item succesfully created...'
      });
    }
  });
  const [isLineOfCoverageModalOpen, toggleLineOfCoverageModal] = useToggle(false);
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: true,
    onToggle: onToggle,
    width: "545px"
  }, /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(ModalHeader, {
    titleText: "Schedule item on LOC",
    onClose: onToggle
  }), isLoading || !linesOfCoverage || isLoadingInsurableItem || !insurableItemIdentifier ? /*#__PURE__*/React.createElement(Flexbox, {
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Padding, {
    size: 24
  }, /*#__PURE__*/React.createElement(CircleSpinnerInline, null))) : /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      lineOfCoverage: undefined,
      endDate: '',
      startDate: ''
    },
    onSubmit: async values => {
      var _values$lineOfCoverag;

      const form = {
        lineOfCoverageUuid: (_values$lineOfCoverag = values.lineOfCoverage) === null || _values$lineOfCoverag === void 0 ? void 0 : _values$lineOfCoverag.uuid,
        endDate: values.endDate,
        startDate: values.startDate,
        insurableItemUuid
      };
      await createScheduledItem(form);
    }
  }, _ref2 => {
    var _values$lineOfCoverag2, _values$lineOfCoverag3, _values$lineOfCoverag4, _values$lineOfCoverag5, _values$lineOfCoverag6, _values$lineOfCoverag7, _values$lineOfCoverag8;

    let {
      handleSubmit,
      isSubmitting,
      values,
      setFieldValue,
      setValues
    } = _ref2;
    return /*#__PURE__*/React.createElement("form", {
      onSubmit: handleSubmit
    }, /*#__PURE__*/React.createElement(MessageBox, {
      variant: "neutral",
      borderless: true,
      message: /*#__PURE__*/React.createElement(Text, null, "You are linking", ' ', /*#__PURE__*/React.createElement(Text, {
        weight: 600,
        display: "inline"
      }, insurableItemIdentifier.insurableItemIdentifier))
    }), /*#__PURE__*/React.createElement(Padding, {
      size: 24
    }, /*#__PURE__*/React.createElement(Field, {
      fieldId: "loc",
      label: "Coverage"
    }, /*#__PURE__*/React.createElement(ObjectSelectionInput, {
      title: "Line of coverage",
      subtitle: "Link line of coverage to the schedule above",
      buttonLabel: values.lineOfCoverage ? 'Line of coverage selected' : 'Select a line of coverage',
      onSelect: toggleLineOfCoverageModal,
      selected: !!values.lineOfCoverage
    }), /*#__PURE__*/React.createElement(LegacyLineOfCoverageSelectorModal, {
      header: "Select line of coverage",
      isOpen: isLineOfCoverageModalOpen,
      onToggle: toggleLineOfCoverageModal,
      onSubmit: lineOfCoverageUuids => {
        var _lineOfCoverage$start, _lineOfCoverage$endDa;

        const lineOfCoverage = find(linesOfCoverage, line => line.uuid === lineOfCoverageUuids[0]);
        setValues({ ...values,
          lineOfCoverage,
          startDate: (lineOfCoverage === null || lineOfCoverage === void 0 ? void 0 : (_lineOfCoverage$start = lineOfCoverage.startDate) === null || _lineOfCoverage$start === void 0 ? void 0 : _lineOfCoverage$start.toDate('UTC').toISOString()) || '',
          endDate: (lineOfCoverage === null || lineOfCoverage === void 0 ? void 0 : (_lineOfCoverage$endDa = lineOfCoverage.endDate) === null || _lineOfCoverage$endDa === void 0 ? void 0 : _lineOfCoverage$endDa.toDate('UTC').toISOString()) || ''
        });
        toggleLineOfCoverageModal(false);
      },
      type: "single",
      linesOfCoverage: linesOfCoverage ?? [],
      initialSelectedLineOfCoverageUuids: [((_values$lineOfCoverag2 = values.lineOfCoverage) === null || _values$lineOfCoverag2 === void 0 ? void 0 : _values$lineOfCoverag2.uuid) ?? ''],
      submitText: "Select",
      loading: !linesOfCoverage
    })), values.lineOfCoverage ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacing, {
      height: 16
    }), /*#__PURE__*/React.createElement(Stack, {
      gap: 32,
      direction: "vertical"
    }, /*#__PURE__*/React.createElement(Columns, {
      gap: 24
    }, /*#__PURE__*/React.createElement(Field, {
      fieldId: "start-date",
      label: "Coverage start date*"
    }, /*#__PURE__*/React.createElement(DatePickerInput2.Controlled, {
      value: values.startDate,
      onChange: value => setFieldValue('startDate', value),
      minDate: (_values$lineOfCoverag3 = values.lineOfCoverage) === null || _values$lineOfCoverag3 === void 0 ? void 0 : (_values$lineOfCoverag4 = _values$lineOfCoverag3.startDate) === null || _values$lineOfCoverag4 === void 0 ? void 0 : _values$lineOfCoverag4.toDate('UTC').toISOString(),
      maxDate: (_values$lineOfCoverag5 = values.lineOfCoverage) === null || _values$lineOfCoverag5 === void 0 ? void 0 : (_values$lineOfCoverag6 = _values$lineOfCoverag5.endDate) === null || _values$lineOfCoverag6 === void 0 ? void 0 : _values$lineOfCoverag6.toDate('UTC').toISOString(),
      timezone: "UTC",
      format: "MM/DD/YYYY"
    })), /*#__PURE__*/React.createElement(Field, {
      fieldId: "end-date",
      label: "Coverage end date*"
    }, /*#__PURE__*/React.createElement(DatePickerInput2.Controlled, {
      value: values.endDate,
      onChange: value => setFieldValue('endDate', value),
      minDate: String(values.startDate),
      maxDate: (_values$lineOfCoverag7 = values.lineOfCoverage) === null || _values$lineOfCoverag7 === void 0 ? void 0 : (_values$lineOfCoverag8 = _values$lineOfCoverag7.endDate) === null || _values$lineOfCoverag8 === void 0 ? void 0 : _values$lineOfCoverag8.toDate('UTC').toISOString(),
      timezone: "UTC",
      format: "MM/DD/YYYY"
    }))))) : null), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Flexbox, {
      gap: 8,
      justifyContent: "flex-end"
    }, /*#__PURE__*/React.createElement(Button, {
      size: "secondary",
      onClick: onToggle
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      loading: isSubmitting
    }, "Link"))));
  })));
}

function InsurableItemInput(_ref) {
  let {
    accountUuid,
    insurableItemType,
    insurableItemVersion
  } = _ref;
  const {
    useQuery
  } = useAdminTRPC();
  const {
    data
  } = useQuery(['insurableItems.getMetadata', {
    insurableItemType,
    insurableItemVersion
  }], {
    suspense: true
  });
  const {
    values: formValues,
    errors,
    setFieldValue
  } = useFormikContext(); // make sure we always have at least an empty object in "data"

  useEffect(() => {
    const formValuesData = get(formValues, 'data');

    if (!formValuesData) {
      setFieldValue('data', {});
    }
  }, [setFieldValue, formValues]);
  return /*#__PURE__*/React.createElement(Stack, {
    gap: 32,
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Field, {
    fieldId: "ii-display-name",
    label: "Display name",
    error: errors.displayName
  }, /*#__PURE__*/React.createElement(Input, {
    testId: "ii-display-name-input",
    type: "text",
    value: formValues.displayName ?? '',
    onChange: value => setFieldValue('displayName', value)
  })), /*#__PURE__*/React.createElement(FormikSchemaInput, {
    name: "data",
    accountUuid: accountUuid,
    schema: data === null || data === void 0 ? void 0 : data.schema
  }), /*#__PURE__*/React.createElement(Field, {
    fieldId: "ii-notes",
    label: "Notes",
    error: errors.notes
  }, /*#__PURE__*/React.createElement(TextareaAutosize, {
    "data-testid": "ii-notes-input",
    value: formValues.notes ?? '',
    onChange: event => setFieldValue('notes', event.target.value)
  })));
}

const EMPTY_INITIAL_VALUES = {
  data: {},
  displayName: '',
  notes: ''
};
function InsurableItemForm(_ref) {
  let {
    accountUuid,
    initialValues = EMPTY_INITIAL_VALUES,
    insurableItemType,
    insurableItemVersion,
    submitText = 'Submit',
    onCancel,
    onSubmit
  } = _ref;
  const form = useFormik({
    initialValues,
    onSubmit,
    validateOnChange: true
  });
  return /*#__PURE__*/React.createElement(FormikProvider, {
    value: form
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: form.handleSubmit
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Flexbox, {
      justifyContent: "center"
    }, /*#__PURE__*/React.createElement(CircleSpinnerInline, null))
  }, /*#__PURE__*/React.createElement(InsurableItemInput, {
    accountUuid: accountUuid,
    insurableItemType: insurableItemType,
    insurableItemVersion: insurableItemVersion
  })), /*#__PURE__*/React.createElement(Spacing, {
    height: 32
  }), /*#__PURE__*/React.createElement(Flexbox, {
    justifyContent: "flex-end"
  }, onCancel && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    size: "secondary",
    type: "button",
    onClick: onCancel
  }, "Cancel"), /*#__PURE__*/React.createElement(Spacing, {
    width: 12
  })), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    disabled: !form.isValid,
    loading: form.isSubmitting
  }, submitText))));
}

function UpdateInsurableItem(_ref) {
  let {
    insurableItem,
    onCancel,
    onSubmitSuccess
  } = _ref;
  const {
    useMutation,
    invalidateQuery
  } = useAdminTRPC();
  const {
    mutateAsync: updateInsurableItem
  } = useMutation('insurableItems.update', {
    onSuccess: () => {
      return invalidateQuery(['insurableItems.getInsurableItems'], {
        exact: false
      });
    }
  });

  async function handleSubmit(values) {
    const response = await updateInsurableItem({
      insurableItemUuid: insurableItem.uuid ?? '',
      displayName: values.displayName,
      notes: values.notes,
      type: insurableItem.type,
      version: insurableItem.version,
      data: values.data ?? {}
    });

    if (onSubmitSuccess && response) {
      onSubmitSuccess(response);
    }
  }

  return /*#__PURE__*/React.createElement(InsurableItemForm, {
    accountUuid: insurableItem.accountUuid,
    insurableItemType: insurableItem.type,
    insurableItemVersion: insurableItem.version,
    initialValues: {
      data: insurableItem.data,
      displayName: insurableItem.displayName,
      notes: insurableItem.notes
    },
    onCancel: onCancel,
    onSubmit: handleSubmit
  });
}

function useScheduledItems(params, options) {
  const {
    useQuery
  } = useAdminTRPC();
  return useQuery(['scheduledItems.getScheduleItems', params], options);
}

function DeleteInsurableItemModal(_ref) {
  let {
    isOpen,
    onDeleteSuccess,
    onToggle,
    insurableItemUuid
  } = _ref;
  const {
    data: schedules,
    isLoading
  } = useScheduledItems({
    insurableItemUuids: [insurableItemUuid],
    onlyAvailable: true
  });
  const {
    useMutation
  } = useAdminTRPC();
  const {
    mutateAsync: deleteInsurableItem
  } = useMutation('insurableItems.delete', {
    onSuccess: onDeleteSuccess
  });
  return /*#__PURE__*/React.createElement(ActionModal, {
    variant: "dangerous",
    isOpen: isOpen,
    title: "Delete schedule",
    isConfirmDisabled: isLoading || !!(schedules && schedules.length > 0),
    confirmText: "Delete",
    onClose: onToggle,
    onConfirm: () => deleteInsurableItem({
      insurableItemUuid
    })
  }, isLoading && /*#__PURE__*/React.createElement(Flexbox, {
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(CircleSpinnerInline, null)), schedules && /*#__PURE__*/React.createElement("div", null, schedules.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Alert, null, /*#__PURE__*/React.createElement(Text, null, "This schedule cannot be deleted because of the following coverages")), /*#__PURE__*/React.createElement(Spacing, {
    height: 12
  }), /*#__PURE__*/React.createElement(Stack, {
    gap: 12,
    direction: "vertical"
  }, schedules.map(schedule => /*#__PURE__*/React.createElement("div", {
    key: schedule.uuid
  }, /*#__PURE__*/React.createElement(DetailCard, {
    eyebrowProps: {
      text: 'Scheduled item'
    },
    title: schedule.lineOfCoverage.definition.readableName,
    subtitle: schedule.lineOfCoverage.displayName,
    defaultExpanded: true
  }, /*#__PURE__*/React.createElement(DefinitionList, {
    items: [{
      type: 'dateRange',
      title: 'Scheduled dates',
      value: `${CalendarDate.fromDate(schedule.startDate, 'UTC').format({
        style: DateFormatStyle.STANDARD
      })} - ${CalendarDate.fromDate(schedule.endDate, 'UTC').format({
        style: DateFormatStyle.STANDARD
      })}`
    }]
  })))))) : /*#__PURE__*/React.createElement(Text, null, "Are you sure?")));
}

function InsurableItemActionMenu(_ref) {
  let {
    isArchived,
    insurableItemUuid,
    onDeleteSuccess,
    permissions = {
      canEdit: false,
      canDelete: false
    }
  } = _ref;
  const {
    popoverRef,
    isPopoverOpen,
    togglePopover,
    targetRef
  } = usePopover({
    excludeTarget: true
  });
  const {
    useMutation,
    invalidateQuery
  } = useAdminTRPC();
  const {
    mutateAsync: archiveInsurableItem
  } = useMutation('insurableItems.archive', {
    onSuccess: () => invalidateQuery(['insurableItems.getInsurableItemWithCoverageData', {
      insurableItemUuid
    }])
  });
  const {
    mutateAsync: unarchiveInsurableItem
  } = useMutation('insurableItems.unarchive', {
    onSuccess: () => invalidateQuery(['insurableItems.getInsurableItemWithCoverageData', {
      insurableItemUuid
    }])
  });
  const [isDeleteModalOpen, toggleDeleteModal] = useToggle(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DeleteInsurableItemModal, {
    isOpen: isDeleteModalOpen,
    insurableItemUuid: insurableItemUuid,
    onToggle: toggleDeleteModal,
    onDeleteSuccess: onDeleteSuccess
  }), /*#__PURE__*/React.createElement(IconButton, {
    type: "more",
    onClick: togglePopover,
    elementRef: targetRef,
    isActive: isPopoverOpen,
    testId: "ii-sheet-actions"
  }), /*#__PURE__*/React.createElement(Portal, {
    name: "ii-sheet-actions-portal"
  }, /*#__PURE__*/React.createElement(Tether, {
    targetRef: targetRef,
    targetAnchor: "bottomRight",
    anchor: "topRight",
    yOffset: 10
  }, /*#__PURE__*/React.createElement(PopoverAnimation, {
    isOpen: isPopoverOpen,
    direction: "up"
  }, /*#__PURE__*/React.createElement(Box, {
    border: 1,
    borderRadius: 3,
    elementRef: popoverRef,
    boxShadow: "card",
    backgroundColor: "white"
  }, /*#__PURE__*/React.createElement(Padding, {
    y: 8
  }, /*#__PURE__*/React.createElement(Menu, {
    items: [permissions.canDelete && isArchived ? {
      label: 'Unarchive',
      onClick: async () => {
        togglePopover();
        await unarchiveInsurableItem({
          insurableItemUuid
        });
      }
    } : undefined, permissions.canDelete ? {
      label: 'Archive',
      onClick: async () => {
        togglePopover();
        await archiveInsurableItem({
          insurableItemUuid
        });
      }
    } : undefined, permissions.canDelete ? {
      label: 'Delete',
      onClick: async () => {
        toggleDeleteModal();
        togglePopover();
      }
    } : undefined].filter(isNotUndefined)
  })))))));
}

function InsurableItemDetailsSheet(_ref) {
  let {
    insurableItemUuid,
    isOpen,
    onToggle,
    onEditSuccess,
    onDeleteSuccess,
    permissions = {
      canEdit: false,
      canDelete: false
    },
    showScheduledLimits = false
  } = _ref;
  return /*#__PURE__*/React.createElement(Sheet, {
    isOpen: isOpen,
    hideOnClickOutside: true,
    onToggle: onToggle,
    width: "960px"
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Padding, {
      size: 24
    }, /*#__PURE__*/React.createElement(CircleSpinnerInline, null))
  }, /*#__PURE__*/React.createElement(InsurableItemSheetDetails, {
    onToggle: onToggle,
    insurableItemUuid: insurableItemUuid,
    permissions: permissions,
    onEditSuccess: onEditSuccess,
    onDeleteSuccess: onDeleteSuccess,
    showScheduledLimits: showScheduledLimits
  })));
}

function InsurableItemSheetDetails(_ref2) {
  let {
    insurableItemUuid,
    onToggle,
    onEditSuccess,
    onDeleteSuccess,
    permissions = {
      canEdit: false,
      canDelete: false
    },
    showScheduledLimits
  } = _ref2;
  const [isEditing, toggleEditing] = useToggle(false);
  const [isAdding, toggleIsAdding] = useToggle(false);
  const {
    useQuery,
    invalidateQuery
  } = useAdminTRPC();
  const {
    data: insurableItem
  } = useQuery(['insurableItems.getInsurableItemWithCoverageData', {
    insurableItemUuid
  }], {
    suspense: true
  }); // insurableItem should be defined since we're using suspense

  if (!insurableItem) {
    return null;
  }

  const isArchived = (insurableItem === null || insurableItem === void 0 ? void 0 : insurableItem.status.status) === InsurableItemStatus.INACTIVE;
  const canManage = permissions.canEdit && permissions.canDelete;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SheetHeader, {
    onToggle: onToggle
  }), /*#__PURE__*/React.createElement(SheetBody, null, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: '32px',
      right: '32px'
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    gap: 12,
    alignItems: "center"
  }, !isEditing && permissions.canEdit && /*#__PURE__*/React.createElement(Button, {
    size: "secondary",
    style: {
      height: 32,
      lineHeight: '32px'
    },
    onClick: toggleEditing
  }, "Edit"), /*#__PURE__*/React.createElement(InsurableItemActionMenu, {
    insurableItemUuid: insurableItem.uuid,
    permissions: permissions,
    onDeleteSuccess: onDeleteSuccess,
    isArchived: isArchived
  }))), /*#__PURE__*/React.createElement(Padding, {
    y: 32,
    x: 32
  }, /*#__PURE__*/React.createElement(SmallCaps, {
    color: colors.grass[400]
  }, "Schedule"), /*#__PURE__*/React.createElement(Text, {
    size: "extraLarge"
  }, insurableItem.definition.readableName, " ", !!insurableItem.displayName && `- ${insurableItem.displayName}`), isArchived && /*#__PURE__*/React.createElement(Padding, {
    y: 20
  }, /*#__PURE__*/React.createElement(MessageBox, {
    variant: "warning",
    message: "Archived"
  })), isEditing && /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(CircleSpinnerInline, null)
  }, /*#__PURE__*/React.createElement(UpdateInsurableItem, {
    insurableItem: insurableItem,
    onCancel: toggleEditing,
    onSubmitSuccess: async updatedInsurableItem => {
      toggleEditing();
      await invalidateQuery(['insurableItems.getInsurableItemWithCoverageData', {
        insurableItemUuid
      }], {
        exact: false
      });

      if (onEditSuccess) {
        onEditSuccess(updatedInsurableItem);
      }
    }
  })), !isEditing && /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(CircleSpinnerInline, null)
  }, /*#__PURE__*/React.createElement(InsurableItemDisplay, {
    insurableItemDetails: insurableItem
  }), /*#__PURE__*/React.createElement(Spacing, {
    height: 24
  }), showScheduledLimits ? /*#__PURE__*/React.createElement(ExpandableModule, {
    label: "Currently covered by",
    defaultExpanded: true,
    onAdd: toggleIsAdding
  }, insurableItem.scheduledItems.map(scheduledItem => /*#__PURE__*/React.createElement("div", {
    key: scheduledItem.uuid
  }, /*#__PURE__*/React.createElement(Spacing, {
    height: 24
  }), /*#__PURE__*/React.createElement(InsurableItemCoverageDisplay, {
    scheduledItem: scheduledItem,
    insurableItemIdentifier: insurableItem.label,
    canManage: canManage
  })))) : insurableItem.policies && insurableItem.policies.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacing, {
    height: 32
  }), /*#__PURE__*/React.createElement(Stack, {
    gap: 16,
    direction: "vertical"
  }, insurableItem.policies.map(policy => /*#__PURE__*/React.createElement(PolicyCard, {
    key: policy.uuid,
    policy: policy
  }))))))), isAdding && /*#__PURE__*/React.createElement(LinkInsurableItem, {
    insurableItemUuid: insurableItemUuid,
    accountUuid: insurableItem.accountUuid,
    onToggle: toggleIsAdding,
    onSuccess: async () => invalidateQuery(['insurableItems.getInsurableItemWithCoverageData', {
      insurableItemUuid
    }], {
      exact: false
    })
  }));
}

function useInsurableItemMetadata(params, options) {
  const {
    useQuery
  } = useAdminTRPC();
  return useQuery(['insurableItems.getMetadata', params], options);
}

function ScheduledLimitCard(_ref) {
  var _scheduledLimit$defin;

  let {
    scheduledLimit,
    getLineOfCoverageLink
  } = _ref;
  const {
    useQuery
  } = useAdminTRPC();
  const {
    data,
    isLoading
  } = useQuery(['scheduledLimits.getMetadata', {
    lineOfCoverageType: scheduledLimit.lineOfCoverageType,
    insurableItemType: scheduledLimit.insurableItemType,
    scheduledLimitType: scheduledLimit.type
  }]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 420
    }
  }, /*#__PURE__*/React.createElement(DetailCard, {
    title: "Scheduled coverage",
    defaultExpanded: true,
    subtitle: (_scheduledLimit$defin = scheduledLimit.definition) === null || _scheduledLimit$defin === void 0 ? void 0 : _scheduledLimit$defin.readableName,
    cardProps: {
      variant: 'compact'
    }
  }, isLoading ? /*#__PURE__*/React.createElement(Flexbox, {
    justifyContent: "center",
    width: "100%"
  }, /*#__PURE__*/React.createElement(CircleSpinnerInline, null)) : /*#__PURE__*/React.createElement(SchemaDefinitionList, {
    scheduledLimit: scheduledLimit,
    getLineOfCoverageLink: getLineOfCoverageLink,
    schema: data === null || data === void 0 ? void 0 : data.schema
  })));
}

function SchemaDefinitionList(_ref2) {
  var _schema$spreadsheet, _scheduledLimit$lineO;

  let {
    scheduledLimit,
    schema,
    getLineOfCoverageLink
  } = _ref2;
  const columns = (_schema$spreadsheet = schema.spreadsheet) === null || _schema$spreadsheet === void 0 ? void 0 : _schema$spreadsheet.columns.map(column => column.fieldName);

  if (!columns || columns.length === 0) {
    return null;
  }

  const lineOfCoverageLink = getLineOfCoverageLink(scheduledLimit.lineOfCoverage);
  return /*#__PURE__*/React.createElement(DefinitionList, {
    items: [...columns.map(propertyName => ({
      type: 'document',
      title: getFieldLabel(propertyName, schema) || '',
      value: getStringifieldScheduledLimitValue(propertyName, schema, scheduledLimit.data)
    })), {
      type: 'document',
      href: lineOfCoverageLink.href,
      onClick: lineOfCoverageLink.onClick,
      title: 'Line of coverage',
      value: (_scheduledLimit$lineO = scheduledLimit.lineOfCoverage) === null || _scheduledLimit$lineO === void 0 ? void 0 : _scheduledLimit$lineO.readableName
    }]
  });
}

function getStringifieldScheduledLimitValue(propertyName, schema, data) {
  const stringValue = getStringifiedFieldValueFromSchema(propertyName, schema, data);

  if (propertyName === 'limit' && data.blanket) {
    return stringValue ? `${stringValue} blanket` : '-';
  }

  return stringValue ?? '-';
}

function CoveredInsurableValuePopover(_ref) {
  let {
    scheduledLimits,
    getLineOfCoverageLink
  } = _ref;
  const [isHovering, hoverRef] = useHoverIntent({
    interval: 200,
    timeout: 200
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: hoverRef
  }, /*#__PURE__*/React.createElement(Popper, {
    style: {
      background: 'transparent',
      border: 0,
      boxShadow: 'none'
    },
    placement: "bottom-end",
    isOpen: isHovering,
    trigger: _ref2 => {
      let {
        triggerRef
      } = _ref2;
      return /*#__PURE__*/React.createElement(Badge, {
        type: "secondary",
        elementRef: triggerRef,
        style: {
          cursor: 'default'
        }
      }, "Covered");
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: 'transparent',
      width: 330,
      minHeight: 250
    }
  }, /*#__PURE__*/React.createElement(Flexbox, {
    flexDirection: "column",
    gap: 12
  }, scheduledLimits.map(scheduledLimit => /*#__PURE__*/React.createElement(ScheduledLimitCard, {
    scheduledLimit: scheduledLimit,
    key: scheduledLimit.uuid,
    getLineOfCoverageLink: getLineOfCoverageLink
  }))))));
}

function InsurableItemsSpreadsheet(_ref) {
  let {
    accountUuid,
    insurableItemType,
    insurableItems: insurableItemsResponse,
    permissions = {
      canEdit: false,
      canDelete: false
    },
    height,
    loading,
    searchQuery,
    getLineOfCoverageLink,
    selectedInsurableItemUuid,
    onSelectInsurableItem,
    showScheduledLimits = false
  } = _ref;
  const {
    data
  } = useInsurableItemMetadata({
    insurableItemType
  }, {
    suspense: true,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchIntervalInBackground: false
  });
  const {
    insurableItems
  } = insurableItemsResponse;
  const {
    useMutation,
    invalidateQuery,
    setQueriesData
  } = useAdminTRPC();
  const {
    mutateAsync: updateInsurableItem
  } = useMutation('insurableItems.updateData', {
    onSuccess: updatedInsurableItem => {
      setQueriesData({
        queryKey: ['insurableItems.getInsurableItems', {
          accountUuid
        }],
        exact: false
      }, current => {
        if (!current) {
          return {
            insurableItems: [],
            insurableValuesProperties: []
          };
        }

        return { ...current,
          insurableItems: current.insurableItems.map(insurableItem => {
            if (insurableItem.uuid === updatedInsurableItem.uuid) {
              return { ...insurableItem,
                data: updatedInsurableItem.data
              };
            }

            return insurableItem;
          })
        };
      });
    }
  });
  const {
    mutateAsync: updateInsurableItemDisplayName
  } = useMutation('insurableItems.updateDisplayName', {
    onSuccess: async () => {
      await invalidateQuery(['insurableItems.getInsurableItems', {
        accountUuid
      }], {
        exact: false
      });
    }
  });
  const selectedInsurableItem = insurableItems.find(insurableItem => insurableItem.uuid === selectedInsurableItemUuid);
  const additionalColumns = useMemo(() => [{
    position: 1,
    column: {
      Header: 'Display name',
      accessor: 'displayName',
      focusable: permissions.canEdit,
      Cell: _ref2 => {
        let {
          value
        } = _ref2;
        return /*#__PURE__*/React.createElement(LineClamp, {
          numOfLines: 2
        }, /*#__PURE__*/React.createElement(Text, null, value || '-'));
      },
      CellPopover: _ref3 => {
        let {
          isOpen,
          cellRef,
          close,
          row
        } = _ref3;
        const form = useFormik({
          onSubmit: async values => {
            await updateInsurableItemDisplayName({
              insurableItemUuid: row.original.uuid,
              displayName: values.displayName
            });
            close();
          },
          initialValues: {
            displayName: row.original.displayName
          }
        });

        if (isOpen) {
          return /*#__PURE__*/React.createElement(CellPopover, {
            cellRef: cellRef,
            onClose: close
          }, /*#__PURE__*/React.createElement("form", {
            onSubmit: form.handleSubmit
          }, /*#__PURE__*/React.createElement(Padding, {
            size: 24
          }, /*#__PURE__*/React.createElement(Field, {
            fieldId: "display-name",
            label: "Display name"
          }, /*#__PURE__*/React.createElement(Input, {
            type: "text",
            placeholder: "Add display name",
            value: form.values.displayName,
            onChange: displayName => form.setFieldValue('displayName', displayName)
          }))), /*#__PURE__*/React.createElement(CellPopoverFooter, {
            loading: form.isSubmitting
          })));
        }

        return null;
      }
    }
  }], [permissions.canEdit, updateInsurableItemDisplayName]);
  const options = useMemo(() => ({
    isEditable: permissions.canEdit
  }), [permissions.canEdit]);
  const handleColumnUpdate = useCallback(async _ref4 => {
    let {
      row,
      payload
    } = _ref4;
    await updateInsurableItem({
      insurableItemUuid: row.uuid,
      data: payload.data,
      type: row.type,
      version: row.version
    });
  }, [updateInsurableItem]);
  const additionalCellRenderers = useMemo(() => {
    if (getLineOfCoverageLink) {
      return Object.fromEntries((insurableItemsResponse.insurableValuesProperties || []).map(insurableValueProperty => [insurableValueProperty, _ref5 => {
        var _row$scheduledLimitsB;

        let {
          row,
          propertyName
        } = _ref5;

        if (insurableValueProperty === propertyName && (((_row$scheduledLimitsB = row.scheduledLimitsByPropertyName) === null || _row$scheduledLimitsB === void 0 ? void 0 : _row$scheduledLimitsB[propertyName]) ?? []).length > 0) {
          var _row$scheduledLimitsB2;

          return /*#__PURE__*/React.createElement(CoveredInsurableValuePopover, {
            scheduledLimits: ((_row$scheduledLimitsB2 = row.scheduledLimitsByPropertyName) === null || _row$scheduledLimitsB2 === void 0 ? void 0 : _row$scheduledLimitsB2[propertyName]) ?? [],
            getLineOfCoverageLink: getLineOfCoverageLink
          });
        }

        return null;
      }]));
    }
  }, [insurableItemsResponse.insurableValuesProperties, getLineOfCoverageLink]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DSLSpreadsheet, {
    accountUuid: accountUuid,
    data: insurableItems,
    schema: data === null || data === void 0 ? void 0 : data.schema,
    loading: loading,
    options: options,
    globalFilter: searchQuery,
    height: height,
    onColumnUpdate: handleColumnUpdate,
    additionalColumns: additionalColumns,
    additionalCellRender: showScheduledLimits ? additionalCellRenderers : undefined,
    tableId: `insurable-item-${insurableItemType}`,
    onColumnClick: _ref6 => {
      let {
        row,
        cellIndex
      } = _ref6;

      // we want to trigger details sheet only if the user clicks on the first row
      if (cellIndex === 0) {
        onSelectInsurableItem(row.uuid);
      }
    }
  }), selectedInsurableItem && /*#__PURE__*/React.createElement(InsurableItemDetailsSheet, {
    onEditSuccess: updatedInsurableItem => onSelectInsurableItem(updatedInsurableItem.uuid),
    onDeleteSuccess: () => onSelectInsurableItem(),
    insurableItemUuid: selectedInsurableItem.uuid,
    isOpen: true,
    onToggle: () => onSelectInsurableItem(),
    permissions: permissions,
    showScheduledLimits: showScheduledLimits
  }));
}

// TODO(gabrielsch): potentially extract this to dsl-schema-ui.
// or move dsl-schema-ui to this package.
function DSLCardDefinitionList(_ref) {
  var _schema$cards;

  let {
    data,
    schema,
    additionalItems = []
  } = _ref;
  const fields = ((_schema$cards = schema.cards) === null || _schema$cards === void 0 ? void 0 : _schema$cards.fields) ?? [];

  if (fields.length === 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement(DefinitionList, {
    items: [...fields.map(propertyName => ({
      type: undefined,
      title: getFieldLabel(propertyName, schema) || '',
      value: getStringifiedFieldValueFromSchema(propertyName, schema, data) ?? '-'
    })), ...additionalItems]
  });
}

function useInsurableItems(params, options) {
  const {
    useQuery
  } = useAdminTRPC();
  return useQuery(['insurableItems.getInsurableItems', params], options);
}

function useLineOfCoverage(params, options) {
  const {
    useQuery
  } = useAdminTRPC();
  return useQuery(['loc.getByUuid', params], options);
}

function useLinesOfCoverage(params, options) {
  const {
    useQuery
  } = useAdminTRPC();
  return useQuery(['loc.getLocs', params], options);
}

function usePolicies(params, options) {
  const {
    useQuery
  } = useAdminTRPC();
  return useQuery(['policies.get', params], options);
}

function InsurableItemCard(_ref) {
  let {
    insurableItem,
    suspend,
    ...props
  } = _ref;
  const {
    data: metadata,
    isLoading,
    error
  } = useInsurableItemMetadata({
    insurableItemType: insurableItem.type,
    insurableItemVersion: insurableItem.version
  }, {
    suspense: suspend,
    keepPreviousData: true
  }); // there is not much to do if the metadata could not be loaded

  if (error) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/jsx-props-no-spreading
      React.createElement(DetailCard, _extends({
        title: "Unknown",
        subtitle: insurableItem.displayName
      }, props), /*#__PURE__*/React.createElement(Text, {
        color: colors.fire[500]
      }, "There was an error while loading this insurable item."))
    );
  }

  return /*#__PURE__*/React.createElement(DetailCard, _extends({
    title: metadata ? getSingleLineSchemaIdentifier(insurableItem.data, metadata.schema) || '-' : '-',
    subtitle: insurableItem.displayName // eslint-disable-next-line react/jsx-props-no-spreading

  }, props), isLoading && /*#__PURE__*/React.createElement(Flexbox, {
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Padding, {
    size: 12
  }, /*#__PURE__*/React.createElement(CircleSpinnerInline, null))), metadata ? /*#__PURE__*/React.createElement(DSLCardDefinitionList, {
    data: insurableItem.data,
    schema: metadata.schema
  }) : null);
}

function CreateInsurableItem(_ref) {
  let {
    accountUuid,
    insurableItemType,
    onCancel,
    onSubmitSuccess
  } = _ref;
  const {
    data
  } = useInsurableItemMetadata({
    insurableItemType
  }, {
    suspense: true
  });
  const definition = data === null || data === void 0 ? void 0 : data.definition;
  const {
    useMutation
  } = useAdminTRPC();
  const {
    mutateAsync: createInsurableItem
  } = useMutation('insurableItems.create', {
    onSuccess: onSubmitSuccess
  });

  async function handleSubmit(values) {
    await createInsurableItem({
      accountUuid,
      insurableItem: {
        displayName: values.displayName,
        notes: values.notes,
        type: insurableItemType,
        version: definition.currentVersion,
        data: values.data || {}
      }
    });
  }

  return /*#__PURE__*/React.createElement(InsurableItemForm, {
    accountUuid: accountUuid,
    insurableItemType: insurableItemType,
    insurableItemVersion: definition.currentVersion,
    onCancel: onCancel,
    onSubmit: handleSubmit
  });
}

function InsurableItemTypeSelectInput(_ref) {
  let {
    placeholder,
    value,
    onChange,
    isClearable
  } = _ref;
  const {
    useQuery
  } = useAdminTRPC();
  const {
    data
  } = useQuery(['insurableItems.getTypes']);
  const options = (data ?? []).map(insurableItemType => ({
    label: insurableItemType.readableName,
    value: insurableItemType.id
  }));
  return /*#__PURE__*/React.createElement(AdvancedSelectInput, {
    isClearable: isClearable,
    options: options,
    placeholder: placeholder,
    value: value,
    onChange: newValue => onChange(newValue)
  });
}

function CreateInsurableItemWorkflow(_ref) {
  let {
    accountUuid,
    insurableItemType: initialInsurableItemType,
    onSubmitSuccess,
    onToggle,
    isOpen
  } = _ref;
  const [insurableItemType, setInsurableItemType] = useState(() => initialInsurableItemType);
  useEffect(() => {
    setInsurableItemType(initialInsurableItemType);
  }, [initialInsurableItemType]);

  const handleOnToggle = () => {
    setInsurableItemType(initialInsurableItemType);
    onToggle();
  };

  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onToggle: handleOnToggle
  }, /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(ModalHeader, {
    onClose: handleOnToggle,
    titleText: "Add Exposure"
  }), /*#__PURE__*/React.createElement(Padding, {
    size: 32
  }, /*#__PURE__*/React.createElement(Stack, {
    gap: 20,
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Field, {
    fieldId: "type",
    label: "Type"
  }, /*#__PURE__*/React.createElement(InsurableItemTypeSelectInput, {
    onChange: value => setInsurableItemType(value),
    value: insurableItemType
  })), insurableItemType && /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Flexbox, {
      justifyContent: "center"
    }, /*#__PURE__*/React.createElement(CircleSpinnerInline, null))
  }, /*#__PURE__*/React.createElement(CreateInsurableItem, {
    accountUuid: accountUuid,
    onSubmitSuccess: onSubmitSuccess,
    insurableItemType: insurableItemType
  }))))));
}

const POLICY_ROLE_PLURALS = {
  ACCOUNT_MANAGER: 'account managers',
  PRODUCER: 'producers'
};
const DEFAULT_AM_EMAILS = new Set(['success@newfront.com', 'bor@newfront.com']);
const DEFAULT_PD_EMAILS = new Set(['success+producer@newfront.com']);
/**
 * Emails that do not have an actual GSuite account, and instead are used as special employee
 * records for specific tasks should still be selectable. We will need this util until users-service
 * is able to deal with employees without GSuite accounts, or until we make sure that no two
 * different employees share the same base email.
 */

function isDefaultEmployee(roleId, email) {
  if (!email) {
    return false;
  }

  if (roleId === PolicyAssignmentRole.ACCOUNT_MANAGER) {
    return DEFAULT_AM_EMAILS.has(email);
  }

  if (roleId === PolicyAssignmentRole.PRODUCER) {
    return DEFAULT_AM_EMAILS.has(email) || DEFAULT_PD_EMAILS.has(email);
  }

  return false;
}

const FUZZY_OPTIONS = {
  keys: ['firstName', 'lastName', 'email']
};
function useRoleMappingsSelect(_ref) {
  let {
    employeeUserUuidsInAccount,
    employees,
    selectedUserUuids
  } = _ref;
  const [selectableEmployeesForPolicy, selectableEmployeesForAccount] = useMemo(() => {
    const userUuidsInAccount = new Set(employeeUserUuidsInAccount);
    const inAccount = employees.filter(_ref2 => {
      let {
        userUuid
      } = _ref2;
      return userUuidsInAccount.has(userUuid);
    });
    const notInAccount = employees.filter(_ref3 => {
      let {
        userUuid
      } = _ref3;
      return !userUuidsInAccount.has(userUuid);
    });
    return [inAccount, notInAccount];
  }, [employeeUserUuidsInAccount, employees]);
  const {
    results: filteredEmployeesForPolicy,
    search: searchEmployeesForPolicy
  } = useFuzzy(selectableEmployeesForPolicy, FUZZY_OPTIONS);
  const {
    results: filteredEmployeesForAccount,
    search: searchEmployeesForAccount
  } = useFuzzy(selectableEmployeesForAccount, FUZZY_OPTIONS);
  const selectedItemsForPolicy = useMemo(() => {
    const selectedUserUuidsSet = new Set(selectedUserUuids);
    return toRecord(employees.filter(_ref4 => {
      let {
        userUuid
      } = _ref4;
      return selectedUserUuidsSet.has(userUuid);
    }), employee => employee.userUuid);
  }, [employees, selectedUserUuids]);
  return {
    filteredEmployeesForAccount,
    filteredEmployeesForPolicy,
    searchEmployeesForAccount,
    searchEmployeesForPolicy,
    selectableEmployeesForAccount,
    selectableEmployeesForPolicy,
    selectedItemsForPolicy
  };
}

const MAX_EMPLOYEES_TO_LIST_FOR_ACCOUNT = 10;

function multiObjectSelectFormatter(employee) {
  return {
    key: employee.userUuid,
    title: `${employee.firstName} ${employee.lastName}`,
    subtitle: employee.title
  };
}

function PolicyRoleMappingsInput(_ref) {
  let {
    accountName,
    canAddToAccount,
    employeeUserUuidsInAccount,
    employees,
    onChange,
    roleId,
    selectedUserUuids
  } = _ref;
  const pluralizedRoleId = POLICY_ROLE_PLURALS[roleId];
  const modalContainerRef = useRef(null);
  const [isAddToAccountModalOpen, setIsAddToAccountModalOpen] = useState(false);
  const [temporarySelectedItemsForAccount, setTemporarySelectedItemsForAccount] = useState({});

  function handleCloseModal() {
    setTemporarySelectedItemsForAccount({});
    setIsAddToAccountModalOpen(false);
  }

  const {
    filteredEmployeesForAccount,
    filteredEmployeesForPolicy,
    searchEmployeesForAccount,
    searchEmployeesForPolicy,
    selectableEmployeesForPolicy,
    selectedItemsForPolicy
  } = useRoleMappingsSelect({
    employeeUserUuidsInAccount,
    employees,
    selectedUserUuids
  });

  function handleRenderOption(employee) {
    if (!employee) {
      return /*#__PURE__*/React.createElement(Text, null, "No data");
    }

    return /*#__PURE__*/React.createElement(Flexbox, {
      key: employee.userUuid,
      alignItems: "center",
      padding: 8
    }, /*#__PURE__*/React.createElement(EmployeeProfile, {
      name: `${employee.firstName} ${employee.lastName}`,
      imageUrl: employee.avatarUrl,
      title: employee.title,
      variant: "small"
    }));
  }

  const addToAccountTitle = `Add new ${pluralizedRoleId} to this account`;
  const footerAction = canAddToAccount ? /*#__PURE__*/React.createElement(Button, {
    size: "secondary",
    onClick: () => setIsAddToAccountModalOpen(true)
  }, /*#__PURE__*/React.createElement(Flexbox, {
    gap: 10,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(IconPlus, null), addToAccountTitle)) : undefined;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MultiObjectSelect, {
    data: filteredEmployeesForPolicy.length === 0 ? selectableEmployeesForPolicy : filteredEmployeesForPolicy,
    formatter: multiObjectSelectFormatter,
    onSelectValue: value => onChange(Object.keys(value)),
    searchFetch: searchEmployeesForPolicy,
    selectedItems: selectedItemsForPolicy,
    renderOptions: handleRenderOption,
    footerAction: footerAction
  }), /*#__PURE__*/React.createElement("div", {
    ref: modalContainerRef
  }, /*#__PURE__*/React.createElement(ModalPortalProvider, {
    elementRef: modalContainerRef
  }, /*#__PURE__*/React.createElement(ActionModal, {
    confirmText: "Add",
    isOpen: isAddToAccountModalOpen,
    variant: "confirm",
    title: addToAccountTitle,
    onClose: handleCloseModal,
    onConfirm: async () => {
      await onChange(Array.from(new Set([...Object.keys(temporarySelectedItemsForAccount), ...Object.keys(selectedItemsForPolicy)])));
      handleCloseModal();
    }
  }, /*#__PURE__*/React.createElement(Text, {
    marginBottom: 16
  }, `Add ${pluralizedRoleId} to service ${accountName}.
              They will be able to access account related information.`), /*#__PURE__*/React.createElement(Field, {
    label: `Add ${pluralizedRoleId}`,
    fieldId: "employees"
  }, /*#__PURE__*/React.createElement(MultiObjectSelect, {
    data: filteredEmployeesForAccount.slice(0, MAX_EMPLOYEES_TO_LIST_FOR_ACCOUNT),
    formatter: multiObjectSelectFormatter,
    onSelectValue: setTemporarySelectedItemsForAccount,
    searchFetch: searchEmployeesForAccount,
    selectedItems: temporarySelectedItemsForAccount,
    renderOptions: handleRenderOption
  }))))));
}

function PolicyRoleMappingsField(_ref) {
  let {
    accountUuid,
    canAddToAccount,
    onChange,
    roleId,
    selectedUserUuids
  } = _ref;
  const pluralizedRoleId = POLICY_ROLE_PLURALS[roleId];
  const isAccountManagerField = roleId === PolicyAssignmentRole.ACCOUNT_MANAGER;
  const isProducerField = roleId === PolicyAssignmentRole.PRODUCER;
  const {
    isLoading: isAccountLoading,
    data: account
  } = useAccountByUuid({
    accountUuid
  });
  const {
    isLoading: areProducersLoading,
    data: producersResult
  } = useProducers({
    enabled: isProducerField
  }); // Account managers can also be assigned as producers for a policy

  const {
    isLoading: areAccountManagersLoading,
    data: accountManagersResult
  } = useAccountManagers({
    enabled: isAccountManagerField || isProducerField
  });
  const employees = useMemo(() => {
    const authRoles = [];
    if (isAccountManagerField) authRoles.push(...AM_ROLES);
    if (isProducerField) authRoles.push(...PRODUCER_ROLES, ...AM_ROLES);
    const authRolesSet = new Set(authRoles);
    const producers = producersResult ? producersResult ?? [] : [];
    const accountManagers = accountManagersResult ? accountManagersResult ?? [] : [];
    return uniqBy([...producers, ...accountManagers].filter(_ref2 => {
      let {
        email,
        roles
      } = _ref2;
      return isDefaultEmployee(roleId, email) || (roles === null || roles === void 0 ? void 0 : roles.some(role => authRolesSet.has(role)));
    }), employee => employee.userUuid);
  }, [accountManagersResult, isAccountManagerField, isProducerField, producersResult, roleId]);
  const isLoading = isAccountLoading || areProducersLoading || areAccountManagersLoading;

  if (isLoading || !account) {
    return /*#__PURE__*/React.createElement(CircleSpinnerInline, {
      label: `Loading ${pluralizedRoleId}...`
    });
  }

  function getEmployeeUserUuidsInAccount() {
    if (isProducerField) return (account === null || account === void 0 ? void 0 : account.producerUserUuids) ?? [];
    if (isAccountManagerField) return (account === null || account === void 0 ? void 0 : account.accountManagerUserUuids) ?? [];
    return [];
  }

  return /*#__PURE__*/React.createElement(PolicyRoleMappingsInput, {
    accountName: account.name,
    canAddToAccount: canAddToAccount,
    onChange: onChange,
    roleId: roleId,
    selectedUserUuids: selectedUserUuids,
    employees: employees,
    employeeUserUuidsInAccount: getEmployeeUserUuidsInAccount()
  });
}

function useEndPolicy(options) {
  const {
    useMutation
  } = useAdminTRPC();
  return useMutation('policies.endPolicy', options);
}

export { CreateInsurableItemWorkflow, InsurableItemCard, InsurableItemsSpreadsheet, LineOfCoverageDisplay, LineOfCoverageTypeSelector, MultiLineOfCoverageSelector, MultiPolicySelector, PolicyRoleMappingsField, PolicyTermFields, PolicyTypeSelector, SingleLineOfCoverageSelector, SinglePolicySelector, useEndPolicy, useInsurableItemMetadata, useInsurableItems, useLineOfCoverage, useLineOfCoverageDefinitions, useLinesOfCoverage, usePolicies };
